import { render, staticRenderFns } from "./CourseSolo.vue?vue&type=template&id=22a1a0b8&scoped=true"
import script from "./CourseSolo.vue?vue&type=script&lang=js"
export * from "./CourseSolo.vue?vue&type=script&lang=js"
import style0 from "./CourseSolo.vue?vue&type=style&index=0&id=22a1a0b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1a0b8",
  null
  
)

export default component.exports